"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createScenePayload = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _underscore = require("underscore");
var _getProgramLayers = require("./getProgramLayers");
/**
 * Creates a scene payload based on program and layout data
 * @param {Object} program - The program data
 * @param {Object|String} sceneLayout - The scene layout id
 * @returns {Object} The scene payload
 */
var createScenePayload = exports.createScenePayload = function createScenePayload(program, sceneLayout) {
  return {
    title: program.title || 'New Scene',
    description: program.description || 'New Description',
    layers: (0, _getProgramLayers.getProgramLayers)(program).map(function (item) {
      return {
        _id: item === null || item === void 0 ? void 0 : item._id,
        layer: (0, _underscore.pick)(item === null || item === void 0 ? void 0 : item.layer, '_id', 'title', 'style', 'animation', 'isContent'),
        source: (0, _underscore.pick)(item === null || item === void 0 ? void 0 : item.source, '_id', 'title', 'description', 'type', 'value', 'hidden', 'order', 'thumbnail')
      };
    }),
    style: program.style,
    layout: (0, _typeof2["default"])(sceneLayout) === 'object' ? sceneLayout.id : sceneLayout
  };
};